/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Heading, isEmpty, Text } from 'bold-ui'
import { Fragment, ReactNode, useMemo } from 'react'

import { MChatFooterInfo } from '../mchat/components/MChatFooterInfo'
import { MChatAnteriorFooterInfoModel } from '../mchat/model-mchat'
import { MCHAT_RF_RESULTADO_COLOR_SCALE_BY_TYPE, MChatRfResultadoType } from '../model-mChatRf'
import { MChatRfResultadoAlert } from './MChatRfResultadoAlert'

interface MChatRfResultadoViewProps {
  type: 'success' | 'warning' | 'error'
  title: string
  label: string
  description: ReactNode
  content?: ReactNode
  footerInfo?: MChatAnteriorFooterInfoModel
}

export function MChatRfResultadoView(props: Readonly<MChatRfResultadoViewProps>) {
  const { title, type, label, description, content, footerInfo } = props

  const hasContent = !isEmpty(content)
  const hasFooterInfo = !isEmpty(footerInfo)
  const styles = useMemo(() => createStyles(type), [type])

  return (
    <Fragment>
      <Heading level={3} fontWeight='normal' style={styles.heading}>
        <strong css={styles.title}>{title}</strong> | <Text fontSize={1}>{label}</Text>
      </Heading>
      {hasContent && <div css={styles.contentWrapper}>{content}</div>}
      <MChatRfResultadoAlert type={type} style={styles.alert}>
        {description}
      </MChatRfResultadoAlert>
      {hasFooterInfo && <MChatFooterInfo mChat={footerInfo} />}
    </Fragment>
  )
}

const createStyles = (type: MChatRfResultadoType) => ({
  heading: css`
    margin-bottom: 0.5rem;
  `,
  title: css`
    color: ${MCHAT_RF_RESULTADO_COLOR_SCALE_BY_TYPE[type].c40};
  `,
  contentWrapper: css`
    padding: 0.5rem 0;
    margin-bottom: 0.5rem;
  `,
  alert: css`
    margin-bottom: 0.5rem;
  `,
})
